// Canonical profile URL from whatever the stylist typed (@handle, bare handle,
// or full URL). The confirm-link under each field lets them verify it's really
// their account — and confirmed links are what the premium AI photo-scout will
// crawl to auto-fill their Style Book and Discover page.
const BASES = {
  instagram: (h) => `https://instagram.com/${h}`,
  tiktok: (h) => `https://tiktok.com/@${h}`,
  twitter: (h) => `https://x.com/${h}`,
  facebook: (h) => `https://facebook.com/${h}`,
  youtube: (h) => `https://youtube.com/@${h}`,
};

// Repair mistyped/duplicated schemes ("https:/x", "https://https:/x") then re-add one.
export function normalizeWebsite(raw) {
  const value = (raw || '').trim();
  if (!value) return '';
  const bare = value.replace(/^(https?:\/*)+/i, '');
  return bare ? `https://${bare}` : '';
}

export function socialUrl(key, raw) {
  const value = (raw || '').trim();
  if (!value) return null;
  if (key === 'website') return normalizeWebsite(value) || null;
  if (/^https?:\/\//i.test(value)) return value;
  const handle = value.replace(/^@+/, '').replace(/\/+$/, '');
  if (!handle) return null;
  // They pasted a URL without a scheme (contains the platform domain already)
  if (handle.includes('.com/') || handle.includes('.co/')) return `https://${handle}`;
  const build = BASES[key];
  return build ? build(handle) : `https://${handle}`;
}

export function socialDisplay(key, raw) {
  const url = socialUrl(key, raw);
  return url ? url.replace(/^https?:\/\//, '') : null;
}
